import { createContext, useContext } from 'react';

import { UserType } from '@constants_common';

export type OtpUserType = Extract<UserType, 'admin' | 'company'>;

export type OtpChallenge = {
  challengeToken: string;
  expiresAt: string;
  emailHint: string;
};

export type DashboardLoginResult =
  | { success: true; data: any }
  | { success: false; otpRequired: true; challenge: OtpChallenge }
  | { success: false; otpRequired?: false; errorCode?: string };

export type VerifyOtpResult =
  | { success: true; data: any }
  | { success: false; status: number; errorCode?: string }
  | undefined;

type AuthContext = {
  userType: UserType;
  dashboardLogin: (formData: FormData, userType: UserType) => Promise<DashboardLoginResult>;
  verifyOtp: (userType: OtpUserType, challengeToken: string, otp: string) => Promise<VerifyOtpResult>;
  isAuthenticated: (params: { userType: UserType; pagePath: string }) => Promise<boolean>;
  logout: (userType: string) => void;
};

export const authContext = createContext<AuthContext | undefined>(undefined);

export const useAuth = () => {
  const context = useContext(authContext);
  if (context === undefined) {
    throw Error('authContext is undefined');
  }
  return context;
};
